import { Toast } from '@easyvaas/js-components';
import React from 'react';
import { useRecoilCallback, useRecoilValue } from 'recoil';
import { useClosePopup } from '../../hooks/useClosePopup';
import { imageItemSelector, pieceItemSelector } from '../../store/selector';
import { imagePopupState, mainTabState, subTabState } from '../../store/state';
import ImageOpreationPopoup from '../ImageOpreationPopup';
import {
  resolveImage,
  exchangeImage,
  imagesV3Data,
  imagesV3Shop
} from '../../services';
import styles from './index.module.scss';
import { useCheckMaterialEnough } from '../../hooks/useCheckMaterialEnough';
const ExchangePopup = () => {
  const { target, type } = useRecoilValue(imagePopupState('exchange'));
  const item = useRecoilValue(imageItemSelector(target));
  const piece = useRecoilValue(pieceItemSelector(item?.piecesType || 0));
  const close = useClosePopup();
  const toMaterails = useRecoilCallback(({ set }) => () => {
    close('exchange');
    set(mainTabState, 3);
    set(subTabState(3), 2);
  });
  const checkMaterial = useCheckMaterialEnough();

  if (!item || !piece) return null;
  const onClick = async () => {
    try {
      if (!item || !piece) return;
      if (type === 2 && !checkMaterial(piece, item.piecesExchange)) return;
      const fn = type === 1 ? resolveImage : exchangeImage;
      Toast.loading(`${type === 1 ? '分解' : '兑换'}中...`);
      await fn({ imgId: item.id });
      const promises = [imagesV3Data.refresh({})];
      if (item.level <= 1) {
        //一阶物品的操作，需要刷新商店;
        promises.push(imagesV3Shop.refresh({}));
      }
      await Promise.all(promises);
      close('exchange');
      Toast(`${type === 1 ? '分解' : '兑换'}成功`);
    } catch ({ message }) {
      Toast(message);
    }
  };

  return (
    <ImageOpreationPopoup
      type="exchange"
      title={type === 1 ? '分解座驾' : '兑换座驾'}
      className={styles.container}
      renderFooter={() =>
        type > 1 && (
          <div
            className={styles.footer}
            onClick={toMaterails}
          >{`获取更多${piece.title}>`}</div>
        )
      }
      onClick={onClick}
    >
      <img className={styles.logo} src={item.url} alt="" />
      <div className={styles.text}>
        你正在{type === 1 ? '分解' : '兑换'}
        {item.title}
      </div>
      <div className={styles.text}>
        {type === 1 ? '分解后获得' : '需要消耗'}
        <span
          style={{ backgroundImage: `url(${piece.logo})` }}
          className={styles.piece}
        />
        <span className={styles.coin}>
          {type === 1 ? item.piecesResolved : item.piecesExchange}
        </span>
      </div>
      {type === 1 && (
        <div className={styles.accent}>分解后座驾即删除，不可恢复</div>
      )}
    </ImageOpreationPopoup>
  );
};

export default React.memo(ExchangePopup);
